import { FC } from 'react';
import { WizardFormData, StepErrors } from '../types';
import SearchDropdown from '../../dropDownInput';

export interface StepTimezoneProps {
    formData: WizardFormData;
    errors: StepErrors;
    timezones: Array<{ label: string; subLabel: string }>;
    onChange: (field: keyof WizardFormData, value: any) => void;
}

/**
 * Step 4 — Timezone Selection
 *
 * Renders a searchable dropdown populated with IANA timezone strings.
 * No pre-selected value on first load. Displays inline error if not
 * selected on validation attempt.
 *
 * Requirements: 6.1, 6.2, 6.3, 6.4
 */
export const Step4_Timezone: FC<StepTimezoneProps> = ({
    formData,
    errors,
    timezones,
    onChange,
}) => {
    const errorId = 'timezone-error';
    const hasError = !!errors.timezone;

    const handleTimezoneSelect = (item: { label: string; subLabel: string }, _id: string) => {
        onChange('timezone', item.label);
    };

    return (
        <div className="wizard-step wizard-step-timezone">
            <div className="wizard-field">
                <div className="user_list_title">Select a Time Zone:</div>
                <div
                    style={hasError ? { border: '1px solid red', borderRadius: '4px' } : undefined}
                    aria-describedby={hasError ? errorId : undefined}
                >
                    <SearchDropdown
                        data={timezones}
                        onSelect={handleTimezoneSelect}
                        selected={formData.timezone}
                        id="timezone"
                        editable={false}
                    />
                </div>
                {hasError && (
                    <span
                        id={errorId}
                        className="wizard-field-error"
                        role="alert"
                        style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}
                    >
                        {errors.timezone}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Step4_Timezone;
